module.exports = __webpack_public_path__ + "img/img-serviceOne.eb015cc6.png";